export default __webpack_public_path__ + "static/media/trips_large.92d8c882.png";